import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ReportType } from '@navstation-portal/reporting/data-model/vessel-report';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { PanelMenu } from 'primeng/panelmenu';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import { engineReportEvents } from '@navstation-portal/reporting/data-access/engine-report';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';
import { reportEvents } from '@navstation-portal/reporting/data-access/vessel-report';
import { injectDispatch } from '@ngrx/signals/events';
import { SideMenuItem } from '../side-menu-constants';

@Component({
  selector: 're-panel-menu',
  templateUrl: './panel-menu.component.html',
  imports: [PanelMenu, IconComponent, RouterLink, ButtonModule, DialogModule],
})
export class PanelMenuComponent {
  IconNames = IconNames;
  @Input() routes: SideMenuItem[] = [];
  @Input() allowedNextReportTypes: string[] = [];
  @Input() enforceReportSequence = true;

  outOfSequenceDialogVisible = false;
  pendingReportType: ReportType | null = null;

  readonly route = inject(ActivatedRoute);
  readonly appStore = inject(AppStore);
  readonly router = inject(Router);
  reportDispatch = injectDispatch(reportEvents);
  engineReportDispatch = injectDispatch(engineReportEvents);

  getRouterLink(
    item: SideMenuItem,
  ): string | readonly unknown[] | null | undefined {
    if (item.createReportType || item.createEngineReportType) return null;

    const routeSegments = item.route?.split('/');
    if (!routeSegments) return [];

    const vesselId = this.appStore.selectedVesselId();
    if (vesselId) routeSegments.unshift(vesselId);

    return routeSegments;
  }

  onItemClick(item: SideMenuItem): void {
    if (item.createEngineReportType) {
      this.engineReportDispatch.createReport({
        reportType: item.createEngineReportType,
      });
      return;
    }

    if (!item.createReportType) return;

    if (
      !this.enforceReportSequence &&
      !this.allowedNextReportTypes.includes(item.createReportType)
    ) {
      this.pendingReportType = item.createReportType;
      this.outOfSequenceDialogVisible = true;
      return;
    }

    this.reportDispatch.createNewReport({
      reportType: item.createReportType,
    });
  }

  confirmOutOfSequence(): void {
    if (this.pendingReportType) {
      this.reportDispatch.createNewReport({
        reportType: this.pendingReportType,
      });
    }
    this.dismissOutOfSequenceDialog();
  }

  dismissOutOfSequenceDialog(): void {
    this.outOfSequenceDialogVisible = false;
    this.pendingReportType = null;
  }
}
